// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"aboutus_sidebar__G4WI6","anchorPane":"aboutus_anchorPane__3M0XO","dopeNav":"aboutus_dopeNav__MbuXo"};